mutation CreateInvoiceFromQuote($input: InvoiceCreateFromQuoteInput!) {
    invoiceCreateFromQuote(input: $input) {
        invoice {
            id
            modalUrl
        }
    }
}
